export default __webpack_public_path__ + "static/media/YouTubeLogo.532c4953.svg";